import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from '@services/api/api.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-role',
  templateUrl: './add-role.component.html',
  styleUrls: ['./add-role.component.scss'],
})
export class AddRoleComponent implements OnInit {
  @Input() isHideSideNav: boolean = true;
  @Output() isRoleCreate = new EventEmitter<boolean>();

  constructor(
    private Api: ApiService,
    private router: Router,
    private toastr: ToastrService
  ) {}
  roleForm: FormGroup;
  public submitted = false;
  ngOnInit() {
    this.roleForm = new FormGroup({
      name: new FormControl('', [Validators.required]),
      description: new FormControl(''),
    });
  }

  // Add new role by checking the validation
  addRole() {
    // If the form is invalid, set submitted to true and stop execution
    if (this.roleForm.invalid) {
      this.submitted = true;
      return false;
    }

    // Get form data and attach office ID from API
    let form_data = this.roleForm.value;
    form_data['office_id'] = this.Api.getOfficeId();

    // Send POST request to create a new role
    this.Api.post('/roles', form_data).subscribe({
      next: _ => {
        // On success, reset submitted flag and show success message
        this.submitted = false;
        this.toastr.success('Role has been created');

        // Emit event or navigate based on context (side nav state)
        if (this.isHideSideNav === false) {
          this.isRoleCreate.emit(true);
        } else {
          this.router.navigateByUrl('/setting/roles');
        }
      },
      error: error => {
        // Show specific error if not server-side, otherwise show generic error
        if (error.message && error.status_code !== 500) {
          let err = error?.message ?? error?.error?.message;
          this.toastr.error(err);
        } else {
          this.toastr.error('Something wrong with the form. Please check and try again.');
        }
      },
    });
  }
}
